<template>
  <div class="inner-box">
    <div slot="content">
      <el-form size="small">
        <div class="content-name">
          <h2 class="dp-ib">권한관리</h2>
          <el-form-item label-width="0px" style="float: right;">
            <el-button type="primary" icon="el-icon-search" @click="goOpen">{{ this.$i18n.messages[this.$store.state.locale].search }}</el-button>
            <el-button type="info" icon="el-icon-close" @click="cancel">취소</el-button>
            <el-button type="danger" icon="el-icon-delete" @click="deleteRow">삭제</el-button>
            <el-button type="primary" icon="el-icon-document-add" @click="save">저장</el-button>
          </el-form-item>
        </div>
      </el-form>

    <!-- 검색조건 영역 -->
      <div class="search-form">
        <el-form size="mini" label-width="80px">
          <el-row style="margin-bottom: 0px;">
            <el-col :span="8">
              <el-form-item label="프로그램분류" label-width="120px">
                <el-select v-model="form.catId">
                  <el-option value='0' label="전체(느림)">전체(느림)</el-option>
                  <el-option
                      v-for="item in combos['Program']"
                      :key="item.key"
                      :value="item.key"
                      :label="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <el-col :span="10">
                <el-form-item label-width="0px">
                  <el-radio-group v-model="form.useYn">
                    <el-radio label ="">전체보기</el-radio>
                    <el-radio label ="Y">할당된 권한</el-radio>
                    <el-radio label ="N">미할당 권한</el-radio>
                  </el-radio-group>
                </el-form-item>
            </el-col>

            <el-col :span="6">
              <el-form-item label="상속된 권한까지 표시" label-width="140px" label-position="right">
                <el-checkbox v-model="form.inheritDispYn"/>
              </el-form-item>
            </el-col>

          </el-row>
        </el-form>
      </div>
    <!-- 테이블 -->
      <div class="talbe-contain" style="display: flex;">
        <div class="table-area" style="margin-right: 50px; width: 25%;">
          <div class="table-b">
<!--            <div class="table-header">-->
<!--              <el-form style="display: grid; float: right;" size="small">-->
<!--                <el-form-item label-width="0px">-->
<!--                  <el-button type="success" icon="el-icon-document-add" @click="addRowd">추가</el-button>-->
<!--                  <el-button type="danger" icon="el-icon-delete" @click="deleteRowd">삭제</el-button>-->
<!--                </el-form-item>-->
<!--              </el-form>-->
<!--            </div>-->
            <ag-grid-vue
                ref="gridMain"
                :style="gridStyle"
                class="ag-theme-alpine"
                :enableRangeSelection="true"
                :headerHeight="0"
                :rowModelType="rowModelType"
                :treeData="true"
                :isServerSideGroup="isServerSideGroup"
                :isServerSideGroupOpenByDefault="isServerSideGroupOpenByDefault"
                :getServerSideGroupKey="getServerSideGroupKey"
                :autoGroupColumnDef="autoGroupColumnDef"
                :animateRows="true"
                :rowData="data"
                :columnDefs="columnDefs"
                :defaultColDef="defaultColDef"
                :gridOptions="gridOptions"
                :suppressRowClickSelection="false"
                @grid-ready="onReadyMain"
                @cell-clicked="onCellClickedMain"
            />
          </div>
        </div>
        <div class="table-area" style="width: 100%;">
          <div class="table-b">
            <ag-grid-vue
                ref="gridSub"
                style="width: 100%; height: 70vh; min-height: 25px;"
                class="ag-theme-alpine"
                :enableRangeSelection="true"
                :columnDefs="columnDefsSub"
                :defaultColDef="defaultColDefSub"
                :frameworkComponents="frameworkComponents"
                :rowData="subData"
                :gridOptions="gridOptionsSub"
                :suppressRowClickSelection="false"
                :statusBar="statusBar"
                @grid-ready="onReadySub"
                @cell-clicked="onCellClickedSub"
            />
          </div>
        </div>
      </div> <!-- table contain -->

    </div>

  </div>
</template>
<script>
import _ from "lodash";

import CheckboxCellRenderer from '@/components/agGrid/checkbox-cell-renderer';
import common from '@/mixin/common';
import GroupSelectList from '@/components/InfoManage/GroupUserSelect.vue';

/**
 * Url JOIN
 */
function _url(...args) {
  args = args.map(x =>
      String(x || "")
          .trim()
          .replace(/^\/*|\/*$/g, "")
  );
  return args.filter(x => x).join("/");
}

export default {
  mixins: [common],
  name: "codeMng",
  components: {GroupSelectList},
  data() {
    return {
      title: "",
      deleteid: "",
      deleteList: [],
      parentNm: "",
      rowData: [],
      form: {
        catKey: "",
        catNm: "",
        catId: "",
        parentId: "",
        topKey: "",
        catIdx: "",
        description: "",
        catValue1: "",
        catValue2: "",
        catValue3: "",
        catValue4: "",
        catValue5: "",
        inheritDispYn: "",
        useYn: "",
        authStatus: "",
      },
      defForm: {
        catKey: "",
        catNm: "",
        catId: "",
        parentId: "",
        topKey: "",
        catIdx: "",
        description: "",
        catValue1: "",
        catValue2: "",
        catValue3: "",
        catValue4: "",
        catValue5: "",
      },
      data: [],
      subData: [],
      gridOptions: {
        //enableColResize: true,
        //enableFilter: true,
        //animateRows: false,
        //enableSorting: true
        rowModelType: 'serverSide',
      },
      gridOptionsSub: {
        getRowStyle:true,
      },
      defaultColDef: {
        resizable: true,
        filter: true,
        sortable: true,
        editable: true,
        width: 240,
        flex: 1,
      },
      defaultColDefSub: {
        resizable: true,
        filter: true,
        sortable: true,
        editable: true,
        width: 240,
        flex: 1,
        //cellStyle : {'justify-content': 'center','align-items': 'center', 'display': 'flex','height': '100%'}
      },
      catDetail: [],
      gridApi: null,
      columnApi: null,
      columnDefs: [],
      gridApiSub: null,
      columnApiSub: null,
      columnDefsSub: [],
      frameworkComponents: null,
      autoGroupColumnDef: null,
      rowModelType: null,
      isServerSideGroupOpenByDefault: null,
      isServerSideGroup: null,
      getServerSideGroupKey: null,
      selectId : "",
      gridStyle : 'padding-top: 0px; width: 100%;height: 70vh; min-height:100px;',
      combos: {
        'Program': []
      },
    };
  },
  methods: {
    //메인그리드 Ready
    onReadyMain(params) {
      //메인그리드 api 정의
      this.gridApi = params.api;
      this.columnApi = params.columnApi;
      this.gridApi.sizeColumnsToFit();

      const updateData = (data) => {
        var fakeServer = this.createFakeServer(data);
        var datasource = this.createServerSideDatasource(fakeServer);
        params.api.setServerSideDatasource(datasource);
        return data;
      };
      this.$http.post(_url("/api/tree/authMng/list"), {
        companyId: this.$store.state.loginInfo.compCd
      }).then(response => {
        let temData = response.data[0].inner_menu;
        let treeData = response.data;
        this.$http.post("/api/authMng/authUser", {
          companyId: this.$store.state.loginInfo.compCd
        }).then(response => {
          temData.forEach(y=>{
            response.data.forEach(x=>{
              let x_inner = [{menu_id : x.userId, menu_nm : x.userNm , menu_key: null, menu_lvl:2 , inner_menu:[] }]
              if(y.menu_id == x.groupUid)y.inner_menu = x_inner;
            });
          });
          treeData[0].inner_menu = temData;
          this.data = updateData(treeData);
        });
      });
    },
    //서브그리드 Ready
    onReadySub(params) {
      //서브그리드 api 정의
      this.gridApiSub = this.gridOptionsSub.api;
      this.columnApiSub = this.gridOptionsSub.columnApi;

      this.gridApiSub.sizeColumnsToFit();
      this.autoSizeAll(this.columnApiSub);
    },
    autoSizeAll(columnApi) {
      const allColumnIds = [];
      columnApi.columnController.gridColumns.forEach((column) => {
        allColumnIds.push(column.getId());
      });
      columnApi.columnController.autoSizeColumns(allColumnIds, false);
    },
    getCheckReadOnly(authStatus,programYn,parameter){

      if(parameter == 'Y') return false;

      return authStatus !== 'I' && programYn !== '' && programYn !== 'N' && programYn !== undefined ? false : true;
    },
    //그리드컬럼 정의
    createColumnDefs() {
      const vm = this

      this.autoGroupColumnDef = {
        field: 'menu_nm',
        cellRendererParams: {
          innerRenderer: (params) => {
            return params.data.menu_nm;
          },
        },
      };
      this.rowModelType = 'serverSide';
      this.isServerSideGroupOpenByDefault = (params) => {
        // open first two levels by default
        return params.rowNode.level < 1;
      };
      this.isServerSideGroup = (dataItem) => {
        // indicate if node is a group
        //console.log(dataItem);
        return dataItem.group;
      };
      this.getServerSideGroupKey = (dataItem) => {
        // specify which group key to use
        return dataItem.menu_id;
      };

      this.columnDefsSub = [
        {
          headerName: '전체'
          , field:'regYn'
          , width : 70
          , editable: false
          , cellRenderer: 'checkboxRenderer'
          , cellRendererParams: {
            trueValue: "1"    //true값  지정 defalut-"Y" ex) "Y", true, "1"
            , falseValue: "0"  //false값 지정 defalut-"N" ex) "N", false, "0"
          },
        },
        {headerName:'ID', field:'programId', width:70, editable:false},
        {headerName:'프로그램명', field:'programFullNm', width:200, editable:false},
        {
          headerName: '조회'
          , field:'grantSelect'
          , width : 70
          , editable: false
          , cellRenderer: 'checkboxRenderer'
          , cellRendererParams: (params) => {
            return {
              trueValue: 'Y',
              falseValue: 'N'
            }
          }
        },
        {
          headerName: '등록'
          , field:'grantInsert'
          , width : 70
          , editable: false
          , cellRenderer: 'checkboxRenderer'
          , cellRendererParams: (params) => {
            return {
              trueValue: 'Y',
              falseValue: 'N',
              disable: this.getCheckReadOnly(params.data.authStatus , params.data.programInsert, this.isEmpty(params.data.parameter) != '' ? 'Y' : 'N')
            }
          }
        },
        {
          headerName: '수정'
          , field:'grantUpdate'
          , width : 70
          , editable: false
          , cellRenderer: 'checkboxRenderer'
          , cellRendererParams: (params) => {
            return {
              trueValue: 'Y',
              falseValue: 'N',
              disable: this.getCheckReadOnly(params.data.authStatus , params.data.programUpdate, this.isEmpty(params.data.parameter) != '' ? 'Y' : 'N')
            }
          }
        },
        {
          headerName: '삭제'
          , field:'grantDelete'
          , width : 70
          , editable: false
          , cellRenderer: 'checkboxRenderer'
          , cellRendererParams: (params) => {
            return {
              trueValue: 'Y',
              falseValue: 'N',
              disable: this.getCheckReadOnly(params.data.authStatus , params.data.programDelete, this.isEmpty(params.data.parameter) != '' ? 'Y' : 'N')
            }
          }
        },
        {
          headerName: '인쇄'
          , field:'grantPrint'
          , width : 70
          , editable: false
          , cellRenderer: 'checkboxRenderer'
          , cellRendererParams: (params) => {
            return {
              trueValue: 'Y',
              falseValue: 'N',
              disable: this.getCheckReadOnly(params.data.authStatus , params.data.programPrint, this.isEmpty(params.data.parameter) != '' ? 'Y' : 'N')
            }
          }
        },
        {
          headerName: '확장권한1'
          , field:'grantExtend1'
          , width : 70
          , editable: false
          , cellRenderer: 'checkboxRenderer'
          , cellRendererParams: (params) => {
            return {
              trueValue: 'Y',
              falseValue: 'N',
              name: 'programExtend1',
              disable: this.getCheckReadOnly(params.data.authStatus , params.data.programExtend1)
            }
          }
        },
        {
          headerName: '확장권한2'
          , field:'grantExtend2'
          , width : 70
          , editable: false
          , cellRenderer: 'checkboxRenderer'
          , cellRendererParams: (params) => {
            return {
              trueValue: 'Y',
              falseValue: 'N',
              name: 'programExtend2',
              disable: this.getCheckReadOnly(params.data.authStatus , params.data.programExtend2)
            }
          }
        },
        {
          headerName: '확장권한3'
          , field:'grantExtend3'
          , width : 70
          , editable: false
          , cellRenderer: 'checkboxRenderer'
          , cellRendererParams: (params) => {
            return {
              trueValue: 'Y',
              falseValue: 'N',
              name: 'programExtend3',
              disable: this.getCheckReadOnly(params.data.authStatus , params.data.programExtend3)
            }
          }
        },
        {
          headerName: '확장권한4'
          , field:'grantExtend4'
          , width : 70
          , editable: false
          , cellRenderer: 'checkboxRenderer'
          , cellRendererParams: (params) => {
            return {
              trueValue: 'Y',
              falseValue: 'N',
              name: 'programExtend4',
              disable: this.getCheckReadOnly(params.data.authStatus , params.data.programExtend4)
            }
          }
        },
        {
          headerName: '확장권한5'
          , field:'grantExtend5'
          , width : 70
          , editable: false
          , cellRenderer: 'checkboxRenderer'
          , cellRendererParams: (params) => {
            return {
              trueValue: 'Y',
              falseValue: 'N',
              name: 'programExtend5',
              disable: this.getCheckReadOnly(params.data.authStatus , params.data.programExtend5)
            }
          }
        },
        {
          headerName: '확장권한6'
          , field:'grantExtend6'
          , width : 70
          , editable: false
          , cellRenderer: 'checkboxRenderer'
          , cellRendererParams: (params) => {
            return {
              trueValue: 'Y',
              falseValue: 'N',
              name: 'programExtend6',
              disable: this.getCheckReadOnly(params.data.authStatus , params.data.programExtend6)
            }
          }
        },
        {
          headerName: '확장권한7'
          , field:'grantExtend7'
          , width : 70
          , editable: false
          , cellRenderer: 'checkboxRenderer'
          , cellRendererParams: (params) => {
            return {
              trueValue: 'Y',
              falseValue: 'N',
              name: 'programExtend7',
              disable: this.getCheckReadOnly(params.data.authStatus , params.data.programExtend7)
            }
          }
        },
        {
          headerName: '확장권한8'
          , field:'grantExtend8'
          , width : 70
          , editable: false
          , cellRenderer: 'checkboxRenderer'
          , cellRendererParams: (params) => {
            return {
              trueValue: 'Y',
              falseValue: 'N',
              name: 'programExtend8',
              disable: this.getCheckReadOnly(params.data.authStatus , params.data.programExtend8)
            }
          }
        },
        {
          headerName: '확장권한9'
          , field:'grantExtend9'
          , width : 70
          , editable: false
          , cellRenderer: 'checkboxRenderer'
          , cellRendererParams: (params) => {
            return {
              trueValue: 'Y',
              falseValue: 'N',
              name: 'programExtend9',
              disable: this.getCheckReadOnly(params.data.authStatus , params.data.programExtend9)
            }
          }
        },
        {headerName:'비고', field:'description', headerClass: 'require-column', width:80, editable:false},
        {headerName:'', field:'authStatus', hide : true}
      ]
    },
    //Main 그리드 SelctionChange 발생
    onCellClickedMain(params) {

      this.rowData = params.data //선택된 Row

      if(this.form.catId == ''){
        this.$swal({ type: 'error', text: '프로그램 분류를 선택해 주세요' })
        return;
      }

      const voRow = params.data //선택된 Row
      this.catDetail = this.defForm;
      this.goOpen();
      // this.$store.commit('loading')
      // this.$http
      //     .post("/api/authMng/detail", {
      //       companyId: this.$store.state.loginInfo.compCd,
      //       programId: this.form.catId,
      //       actorType: "GROUP",
      //       actorId: voRow.menu_id,
      //       inheritDispYn: this.form.inheritDispYn == true?'Y':'N',
      //       useYn: this.form.useYn,
      //       sortType : true,
      //       page : 1,
      //       totalPage : 9999,
      //       totalCount : 9999,
      //       curPage : 0,
      //       processTime : ""
      //     })
      //     .then(response => {
      //       this.subData = response.data
      //       this.selectId = voRow.menu_id;
      //     }).finally(() => {
      //   this.$store.commit('finish')
      //   this.autoSizeAll(this.columnApiSub);
      // });
    },
    onCellClickedSub(params) {
      this.gridApiSub = this.gridOptionsSub.api;
      this.columnApiSub = this.gridOptionsSub.columnApi;
    },
    goOpen() {

      const voRow = this.rowData;

      console.log('voRow   ', voRow);

      if(this.form.catId == ''){
        this.$swal({ type: 'warning', text: '프로그램 분류를 선택해 주세요' })
        return;
      }

      if(voRow.length == 0) {
        this.$swal({ type: 'warning', text: '권한그룹을 선택해주세요.' })
        return;
      }

      // detail 재실행
      this.$store.commit('loading')
      this.$http
          .post("/api/authMng/detail", {
            companyId: this.$store.state.loginInfo.compCd,
            programId: this.form.catId,
            actorType: voRow.menu_lvl == 2 ? "USER" : "GROUP",
            actorId: voRow.menu_id,
            inheritDispYn: this.form.inheritDispYn == true?'Y':'N',
            useYn: this.form.useYn,
            sortType : true,
            page : 1,
            totalPage : 9999,
            totalCount : 9999,
            curPage : 0,
            processTime : ""
          })
          .then(response => {
            this.subData = response.data
            this.selectId = voRow.menu_id;
          }).finally(() => {
        this.$store.commit('finish')
        this.autoSizeAll(this.columnApiSub);
      });

    },
    save() {

      const grid = this.$refs.gridSub

      const chkDatas = grid.rowData.filter((x,i) => {
        return x.regYn === "1"
      })

      if(chkDatas.length == 0){
        this.$swal({ type: 'error', text: '수정할 권한을 체크하세요.' });
        return false;
      }

      let subData = chkDatas;
      let submitList = [];

      for(var i=0; subData.length > i; i++){
        submitList.push({
          companyId: this.$store.state.loginInfo.compCd,
          programId:subData[i].programId,
          actorType:subData[i].actorType,
          actorId:subData[i].actorId,
          grantSelect:subData[i].grantSelect,
          grantInsert:subData[i].grantInsert,
          grantUpdate:subData[i].grantUpdate,
          grantDelete:subData[i].grantDelete,
          grantPrint:subData[i].grantPrint,
          grantExtend1:subData[i].grantExtend1,
          grantExtend2:subData[i].grantExtend2,
          grantExtend3:subData[i].grantExtend3,
          grantExtend4:subData[i].grantExtend4,
          grantExtend5:subData[i].grantExtend5,
          grantExtend6:subData[i].grantExtend6,
          grantExtend7:subData[i].grantExtend7,
          grantExtend8:subData[i].grantExtend8,
          grantExtend9:subData[i].grantExtend9,
          description:subData[i].description,
          creatorId:this.$store.state.loginInfo.id,
          processTime:""
        });
      }

      this.$http.put('/api/authMng/save',submitList)
          .then(response => {
            this.$swal({ type: 'success', text: '수정되었습니다.' });
            this.goOpen();
          })
          .catch(({ message }) => {
            if (message === "Request failed with status code 500") {
              this.$swal({ type: "error", text: "오류가 발생했습니다." });
            }
          });

    },
    deleteRow() {

      const grid = this.$refs.gridSub

      const chkDatas = grid.rowData.filter((x,i) => {
        return x.regYn === "1"
      })

      if(chkDatas.length == 0)this.$swal({ type: 'error', text: '삭제할 권한을 체크하세요.' });

      let subData = chkDatas;
      let submitList = [];

      for(var i=0; subData.length > i; i++){
        submitList.push({
          companyId: this.$store.state.loginInfo.compCd,
          programId:subData[i].programId,
          actorType:subData[i].actorType,
          actorId:subData[i].actorId,
          processTime:""
        });
      }

      this.$http.put('/api/authMng/delete',submitList)
          .then(response => {
            this.$swal({ type: 'success', text: '권한 삭제 되었습니다.' });
            this.goOpen();
          })
          .catch(({ message }) => {
            if (message === "Request failed with status code 500") {
              this.$swal({ type: "error", text: "오류가 발생했습니다." });
            }
          });
    },
    addRow() {
      this.data.push({
        groupCd: "",
        groupNm: "",
        useYn: "Y",
        groupDesc: "",
        compCd: this.$store.state.loginInfo.compCd,
      });
    },
    deleteRowd() {
      try{

        const row = this.gridApiSub.getSelectedNodes()

        if(row.length < 1)
          throw '선택된 행이 없습니다.'

        let index = row[0].rowIndex
        this.subData.splice(index, 1)

      }catch (e) {
        this.$swal({
          type: 'warning',
          text: e
        })
      }
    },
    addRowd() {
      let vm = this;
      this.$http
          .post("/api/userMng/user/list", {
            companyId: this.$store.state.loginInfo.compCd,
            groupUid : 0,
            userNm : '',
            sortType : true,
            page : 1,
            totalPage : 9999,
            totalCount : 9999,
            curPage : 0,
            processTime : ""
          })
          .then(response => {
            this.$modal.open({
              width: 800,
              component: GroupSelectList,
              parent: vm,
              props: {
                data: response.data
              },
              events: {
                close(data) {
                },
              }
            });
          }).finally(() => {
            this.$store.commit('finish')
        });



    },
    isEmpty(value){
      if( value == "" || value == null || value == undefined || ( value != null && typeof value == "object" && !Object.keys(value).length ) ){
        return ""
      }else{
        return value
      }
    },
    cancel(){
      // CatInfo 초기화
    },
    createFakeServer(ServerData) {
      const Server = {
        data: ServerData,
        getData: function (request) {
          function extractRowsFromData(groupKeys, data) {
            if (groupKeys.length === 0) {
              return data.map(function (d) {
                var has_inner_menu = d.inner_menu.length == 0? false : true;
                return {
                  group:  has_inner_menu,
                  menu_id: d.menu_id,
                  menu_nm: d.menu_nm,
                  menu_lvl: d.menu_lvl
                };
              });
            }
            var key = groupKeys[0];
            for (var i = 0; i < data.length; i++) {
              if (data[i].menu_id === key) {
                return extractRowsFromData(
                    groupKeys.slice(1),
                    data[i].inner_menu.slice()
                );
              }
            }
          }
          return extractRowsFromData(request.groupKeys, this.data);
        },
      };
      return Server;
    },
    createServerSideDatasource(fakeServer) {
      const dataSource = {
        getRows: (params) => {
          //console.log('ServerSideDatasource.getRows: params = ', params);

          var allRows = fakeServer.getData(params.request);
          var request = params.request;
          var doingInfinite = request.startRow != null && request.endRow != null;
          var result = doingInfinite
              ? {
                rowData: allRows.slice(request.startRow, request.endRow),
                rowCount: allRows.length,
              }
              : { rowData: allRows };
          setTimeout(function () {
            params.success(result);
          }, 200);
        },
      };
      return dataSource;
    }
  },
  beforeMount() {

    this.createColumnDefs(); //그리드 컬럼정의 함수 호출

    this.frameworkComponents = {//그르드에서 사용할 외부 comp 등록
      checkboxRenderer: CheckboxCellRenderer,
    };

    this.gridOptionsSub.getRowStyle  = function(params){
      if (params.data.authStatus === 'I') {
        return {background: 'silver'};
      } else if (params.data.authStatus === 'Y') {
        return {background: '#D6F9FB'};
      }
    }

  },
  mounted() {

    this.$http.post(`/api/program/programMng/init`,{
      companyId: this.$store.state.loginInfo.compCd
    }).then(response => {
      this.combos['Program'] = response.data.program;
    })

  },
  created() {
    this.statusBar = {
      statusPanels: [
        { statusPanel: 'agTotalRowCountComponent', align: 'right' },
      ],
    };
  },
};

</script>